import { NgModule } from '@angular/core';

import { SharedModule } from "../../shared/shared.module";
import { FormaControleApiService } from "./shared/forma-controle-api.service";
import { FormaControleService } from "./shared/forma-controle.service";

@NgModule({
    imports: [
        SharedModule
    ],
    providers:[
        FormaControleApiService,
        FormaControleService
    ],
    declarations: []
})
export class FormasControleModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/formas-controle/formas-controle.module.ts
 **/